import { createContext, useEffect, useState } from "react";

export const defaultPolicy = {
	action: 3,
	hasExploit: null,
	hasPatch: null,
	levels: {
		organizations: [],
		companies: [],
		groups: [],
		computers: [],
	},
	severities: [],
	products: [],
	vendors: [],
	cveIds: [],
};

export const ActivePolicyContext = createContext();
export const ActivePolicyProvider = ({ children }) => {
	const [activePolicy, setActivePolicy] = useState(defaultPolicy);

	useEffect(() => {
		if (!activePolicy) setActivePolicy(defaultPolicy);
	}, [activePolicy]);

	return <ActivePolicyContext.Provider value={{ activePolicy, setActivePolicy, defaultPolicy }}>{children}</ActivePolicyContext.Provider>;
};
